module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Oberhallau-342bce75e589c6cce65fcd7c185ed588.png";